import React from "react";

const ProductSkeleton = () => {
  return (
    <div className="bg-white pb-10 animate-pulse">
      <div className="container mx-auto px-6 md:px-10">

        {/* Header Skeleton */}
        <div className="flex justify-between items-center mb-10">
          <div className="h-8 w-52 bg-gray-300 rounded"></div>
          <div className="flex gap-6">
            <div className="h-5 w-20 bg-gray-300 rounded"></div>
            <div className="h-5 w-20 bg-gray-300 rounded"></div>
            <div className="h-5 w-20 bg-gray-300 rounded"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 items-start">
          {/* Banner Skeleton */}
          <div className="lg:col-span-1 h-[493px] bg-gray-300 rounded-2xl"></div>

          {/* Product Skeleton Cards */}
          <div className="lg:col-span-3 flex gap-6 overflow-hidden">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="min-w-[280px] max-w-[280px] flex flex-col bg-gray-200 rounded-2xl"
              >
                <div className="h-[300px] bg-gray-300 rounded-t-2xl"></div>

                <div className="p-5 space-y-3">
                  <div className="h-4 w-40 bg-gray-300 rounded"></div>
                  <div className="h-4 w-28 bg-gray-300 rounded"></div>

                  <div className="h-6 w-24 bg-gray-300 rounded mt-4"></div>

                  <div className="h-10 w-full bg-gray-300 rounded-lg mt-5"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSkeleton;
